import { render, staticRenderFns } from "./moreInviteType.vue?vue&type=template&id=2cc0c434&scoped=true&"
import script from "./moreInviteType.vue?vue&type=script&lang=js&"
export * from "./moreInviteType.vue?vue&type=script&lang=js&"
import style0 from "./moreInviteType.vue?vue&type=style&index=0&id=2cc0c434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0c434",
  null
  
)

export default component.exports